import { render, staticRenderFns } from "./ToggleMailboxDialog.vue?vue&type=template&id=0cf86a2b&"
import script from "./ToggleMailboxDialog.vue?vue&type=script&lang=ts&"
export * from "./ToggleMailboxDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports